import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useUser } from '../UserContext.js';
import { db } from '../auth.js';
import { collection, doc, getDoc, getDocs, addDoc, updateDoc, serverTimestamp, query, orderBy } from "firebase/firestore";

const ProjectPage = () => {
    const user = useUser();
    const [items, setItems] = useState([]);
    const [i, setI] = useState(0);
    const goPath = useNavigate();
    const [clickBtn, setClickBtn] = useState(false);

    useEffect(() => {
        if (!user) {
            goPath('/');
            return;
        }

        const takeData = async () => {
            const order = query(collection(db, "user", user.uid, "project"),
                orderBy("time", "desc"));
            const querySnapshot = await getDocs(order);
            let itemGroup = [];
            querySnapshot.forEach(doc => {
                const newItem = {
                    id: doc.id,
                    name: doc.data().name
                };
                itemGroup.push(newItem);
            });
            setItems(itemGroup);
            const docSnap = await getDoc(doc(db, "user", user.uid));
            if (docSnap.exists()) {
                setI(docSnap.data().projectNum + 1);
            }
        };

        takeData().catch((err) => {
            console.log(err);
        });
    }, [user, goPath]);

    function handleClick() {
        if (!clickBtn && user) {
            setClickBtn(true);
            const time = serverTimestamp();
            const pushData = async () => {
                const docRef = await addDoc(collection(db, "user", user.uid, "project"), {
                    firstTimeEdit: true,
                    name: 'project' + i,
                    time: time,
                    release: false
                });
                await updateDoc(doc(db, "user", user.uid), { projectNum: i });
                const path = '/edit/' + docRef.id;
                goPath(path);
            }
            pushData()
                .catch((err) => {
                    console.log(err);
                });
        }
    }
    return (
        <div className="container" style={{ 'alignItems': 'start' }}>
            <h1 className='project-title'>Projects</h1>
            <Project items={items} handleClick={handleClick} />
        </div>
    )
}

const Project = props => {
    return (
        <ul className='project-list'>
            {props.items.map(item => (
                <li key={item.id}>
                    <Link to={'/edit/' + item.id}>
                        <div className='project-img'>
                            <img src="../image/icon_edit_white.png" className='img-icon' />
                            <img src="../image/bg.jpg" className='img-main' />
                        </div>
                        <div className='project-name'>{item.name}</div>
                    </Link>
                </li>
            ))}
            <li>
                <button onClick={props.handleClick}>+</button>
            </li>
        </ul>
    )
}

export default ProjectPage;
